import React, { memo, UIEvent } from 'react';
import StyledSideNav from './StyledSideNav';
import {
  SideNavCategory,
  SideNavColorSchemeProps,
  SideNavItemSelectEvent,
} from './index';
import CategoriesPanel from './category-panel/CategoriesPanel';
import SubCategoryPanel from './sub-category-panel/SubCategoryPanel';
import { noop } from '../../util';
import { StringOrComponent } from '../../models';

interface SideNavProps extends SideNavColorSchemeProps {
  categories: Array<SideNavCategory>;
  isSearching: boolean;
  setIsSearching: (boolean) => void;
  categoriesToSearch?: Array<SideNavCategory>;
  selectedCategory?: SideNavCategory;
  selectedSubCategory?: SideNavCategory;
  isLoading?: boolean;
  isDraggable?: boolean;
  dropableId?: string;
  onCategorySelect?: (e: SideNavItemSelectEvent) => void;
  onSubCategorySelect?: (e: SideNavItemSelectEvent) => void;
  onSubcategoryPanelScroll?: (e: UIEvent<HTMLElement>) => void;
  onItemDoubleClick?: () => void;
  subItemDisplayBuilder?: (category: SideNavCategory) => StringOrComponent;
  subItemListBuilder?: (
    category: SideNavCategory,
    defaultItemComponents?: StringOrComponent[],
  ) => StringOrComponent;
  refreshFieldsCallback: () => void;
  canShowRefresh: boolean;
  onCloseRefreshPanel: () => void
}

function SideNav({
  categories,
  isSearching,
  setIsSearching,
  categoriesToSearch,
  colorScheme,
  selectedCategory,
  selectedSubCategory,
  isLoading,
  isDraggable,
  dropableId,
  subItemDisplayBuilder,
  subItemListBuilder,
  onSubCategorySelect,
  onCategorySelect,
  onSubcategoryPanelScroll,
  onItemDoubleClick,
  refreshFieldsCallback,
  canShowRefresh,
  onCloseRefreshPanel
}: SideNavProps): JSX.Element {
  return (
    <StyledSideNav>
      <CategoriesPanel
        isLoading={isLoading}
        colorScheme={colorScheme}
        categories={categories}
        onItemSelect={onCategorySelect}
        selectedItem={selectedCategory}
        isSearching={isSearching}
      />
      <SubCategoryPanel
        isLoading={isLoading}
        isDraggable={isDraggable}
        dropableId={dropableId}
        colorScheme={colorScheme}
        category={selectedCategory}
        onItemSelect={onSubCategorySelect}
        selectedItem={selectedSubCategory}
        onScroll={onSubcategoryPanelScroll}
        onItemDoubleClick={onItemDoubleClick}
        subItemDisplayBuilder={subItemDisplayBuilder}
        subItemListBuilder={subItemListBuilder}
        setIsSearching={setIsSearching}
        categoriesToSearch={categoriesToSearch}
        refreshFieldsCallback={refreshFieldsCallback}
        canShowRefresh={canShowRefresh}
        onCloseRefreshPanel={onCloseRefreshPanel}
      />
    </StyledSideNav>
  );
}

SideNav.defaultProps = {
  colorScheme: 'dark',
  onSubCategorySelect: noop,
  onCategorySelect: noop,
};

export default memo(SideNav);
